<template>
  <!-- Mystic AIda, a square (Mystics are squares, seekers circles). -->
  <svg viewBox="0 0 100 100" aria-hidden="true" class="aida-sq">
    <defs>
      <radialGradient :id="id" cx=".5" cy=".3" r=".85"><stop offset="0" stop-color="#9a6ad9" /><stop offset="1" stop-color="#22113f" /></radialGradient>
      <clipPath :id="id + 'c'"><rect width="100" height="100" rx="13" /></clipPath>
    </defs>
    <g :clip-path="`url(#${id}c)`">
      <rect width="100" height="100" :fill="`url(#${id})`" />
      <circle cx="18" cy="14" r="1" fill="#fff" opacity=".7" /><circle cx="78" cy="22" r="1.2" fill="#fff" opacity=".7" />
      <circle cx="64" cy="9" r=".8" fill="#fff" opacity=".7" />
      <ellipse cx="50" cy="46" rx="15" ry="18" fill="#120826" />
      <path d="M14 104 C16 76 32 66 50 66 C68 66 84 76 86 104 Z" fill="#120826" />
      <path d="M31 48 C30 22 70 22 69 48" fill="none" stroke="#f0d9a3" stroke-width="1.6" opacity=".75" />
      <path d="M50 22 l1.6 4 4 1.6 -4 1.6 -1.6 4 -1.6 -4 -4 -1.6 4 -1.6z" fill="#f0d9a3" />
    </g>
    <rect x="1" y="1" width="98" height="98" rx="12" fill="none" stroke="#f0d9a3" stroke-width="2" />
  </svg>
</template>

<script setup>
const id = 'altar-aida-' + Math.random().toString(36).slice(2, 8)
</script>
